<template>
    <div class="input-box">
    <div>
      <div>
        <div class="radio-btns">
          <p>ラベル：</p>
            <label v-for="color in colors" :key="color" :class="inputItemColor">
              <input name="color" type="radio" :value="color" v-model="inputItemColor">
            </label>
          </div>
        </div>
        <label>
          <p>持ち物：</p>
          <input type="text"
          v-model="inputItemName" required>
        </label>
      </div>
      <div class="input-box-btns">
        <button @click="cancel">キャンセル</button>
        <button @click="newShioriItem">決定</button>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      inputItemColor: "blue",
      inputItemName: "",
      colors: ["blue", "red", "green", "yellow"]
    }
  },
  computed: {
    shioriItems: {
      get() {
        return this.$store.getters.shioriItems;
      },
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel');
      this.inputItemColor = "blue";
      this.inputItemName = "";
    },
    newShioriItem() {
      if(this.inputItemName === "") {
        alert("入力されていない項目があります");
        return;
      }
        this.$emit('new-item', this.inputItemColor, this.inputItemName)
        this.inputItemColor = "blue";
        this.inputItemName = "";
    },
  }
}
</script>